<template>
  <!--组织邀请链接失效-->
  <login-layout :title="layoutTit">
    <div class="inivite-join-result">
      <a-form>
        <a-form-item>
          <i class="iconfont iconicon-test68" />
        </a-form-item>
        <a-form-item>
          <p class="item_text">
            {{ $t('message["1438"]') }}
          </p>
        </a-form-item>
        <a-form-item class="invite-re-btn">
          <a-button
            class="login-btn"
            type="primary"
            @click="toIndex"
          >
            {{ $t('message["537"]') }}
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </login-layout>
</template>
<script>
import LoginLayout from '@/components/pc/organization/invite/Link'
export default {
  'name': 'InviteLogin',
  components: {
    LoginLayout
  },
  data () {
    return {
    }
  },
  computed: {
    layoutTit () {
      return this.$t('message["1381"]')
    }
  },
  methods: {
    toIndex () {
      this.$router.push({ name: 'OrgIndex' })
    }
  }
}
</script>

<style lang="scss"  scoped>

.inivite-join-result {
  margin-top: 52px;

  .login-btn {
    display: block;
    width: 100%;
  }

  .ant-row {
    margin: 8px 0;
    text-align: center;

    .item_text {
      color: #333;
      line-height: 1.71;
      font-weight: 600;
    }

    .icon-clear {
      font-size: 40px;
      color: #f57676;
    }
  }

  .invite-re-btn {
    margin: 24px 0 24px;
  }
}
</style>
